module.exports = __webpack_public_path__ + "static/media/list_sort_arrow_active.15d57392.svg";